import type { ReactNode } from 'react'

export type TabItem = {
  key: string
  label: ReactNode
  /** 角标数量，>0 才显示 */
  count?: number
  /** 角标配色：danger 强调待办，neutral 信息数 */
  countTone?: 'danger' | 'neutral'
}

export type TabsProps = {
  tabs: TabItem[]
  active: string
  onChange: (key: string) => void
  className?: string
}

export function Tabs({ tabs, active, onChange, className = '' }: TabsProps) {
  return (
    <div className={`flex items-center gap-1 border-b border-[var(--color-line)] max-md:overflow-x-auto ${className}`.trim()} role="tablist">
      {tabs.map((tab) => {
        const selected = tab.key === active
        return (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={selected}
            onClick={() => onChange(tab.key)}
            className={`relative -mb-px inline-flex min-h-[var(--control-height)] shrink-0 items-center gap-1.5 whitespace-nowrap border-b-2 px-3 text-sm transition-colors ${
              selected
                ? 'border-[var(--color-primary)] font-medium text-[var(--color-primary)]'
                : 'border-transparent text-[var(--color-muted)] hover:text-[var(--color-ink)]'
            }`}
          >
            {tab.label}
            {tab.count !== undefined && tab.count > 0 ? (
              <span
                className={`rounded-[var(--radius-pill)] px-1.5 text-xs leading-4 ${
                  tab.countTone === 'neutral'
                    ? 'bg-[var(--color-soft)] text-[var(--color-muted)]'
                    : 'bg-[var(--color-danger)] text-[var(--color-on-primary)]'
                }`}
              >
                {tab.count}
              </span>
            ) : null}
          </button>
        )
      })}
    </div>
  )
}
